import React from 'react';
import Icon from '../home/Icon';
import ProductPage from '../product-page/ProductPage';
import { FLEET_PAGE } from './fleetData';
import './FleetManagement.css';

const inr = (n) => '₹' + n.toLocaleString('en-IN');

// Illustrative tanker trip: 18 KL over 112 km at ₹4.50 per KL per km.
const TRIP = { kl: 18, km: 112, rate: 4.5, litres: 38, dieselRate: 95 };
const freight = Math.round(TRIP.kl * TRIP.km * TRIP.rate);
const COSTS = [
  { label: 'Diesel · fuel card', meta: `${TRIP.litres} L`, amount: TRIP.litres * TRIP.dieselRate },
  { label: 'Tolls · FASTag', meta: '2 plazas', amount: 540 },
  { label: 'Driver allowance · cash', meta: 'vs advance', amount: 600 },
];
const costTotal = COSTS.reduce((s, c) => s + c.amount, 0);
const STAGES = ['Planned', 'Dispatched', 'Delivered', 'Settled', 'Invoiced'];
const AT = 2; // Delivered

const TripMock = () => (
  <div aria-hidden="true">
    <div className="pp-window">
      <div className="pp-window-bar">
        <span className="pp-window-crumb">Fleet › Trips › TR-0418</span>
        <span className="pp-window-tag"><span className="pp-live-dot" />Delivered</span>
      </div>
      <div className="pp-window-body fl-trip">
        <div className="fl-stages">
          {STAGES.map((s, i) => (
            <span key={s} className={`fl-stage ${i < AT ? 'is-done' : ''} ${i === AT ? 'is-now' : ''}`}>
              <i>{i < AT ? '✓' : i + 1}</i>{s}
            </span>
          ))}
        </div>
        <div className="fl-route">
          <div><small>From</small><strong>Vatva GIDC</strong></div>
          <span className="fl-route-line"><Icon name="truck" size={15} /><em>{TRIP.km} km</em></span>
          <div><small>To</small><strong>Dahej SEZ</strong></div>
        </div>
        <div className="fl-fields">
          <div><small>Vehicle</small><span>GJ-06-AZ-4471 · Tanker 20 KL</span></div>
          <div><small>Driver</small><span>R. Yadav <span className="pp-chip pp-chip--ok">Hazardous ✓</span></span></div>
          <div><small>LR · e-Way Bill</small><span>LR-2219 · EWB 7712 0094 3381</span></div>
          <div><small>Load</small><span>{TRIP.kl} KL · sealed</span></div>
        </div>
        <div className="fl-money">
          <div className="fl-money-row fl-money-head"><span>Freight · rate card ₹{TRIP.rate}/KL/km</span><strong>{inr(freight)}</strong></div>
          {COSTS.map((c) => (
            <div className="fl-money-row" key={c.label}><span>{c.label} <small>{c.meta}</small></span><span>−{inr(c.amount)}</span></div>
          ))}
          <div className="fl-money-row fl-money-total"><span>Trip margin · {(TRIP.km / TRIP.litres).toFixed(1)} km/L</span><strong>{inr(freight - costTotal)}</strong></div>
        </div>
      </div>
    </div>
    <div className="pp-float pp-float--tr">
      <span className="pp-float-icon pp-float-icon--warn"><Icon name="file-warning" size={14} /></span>
      <span><strong>Dispatch blocked · GJ-01-KT-4482</strong><small>PUC lapsed yesterday</small></span>
    </div>
    <div className="pp-float pp-float--bl">
      <span className="pp-float-icon pp-float-icon--ok">✓</span>
      <span><strong>Freight bill FB-0087 approved</strong><small>GST invoice raised in Sales</small></span>
    </div>
  </div>
);

const POSTINGS = [
  { doc: 'Freight bill', icon: 'receipt-indian-rupee', to: 'GST sales invoice', detail: 'Receivable, freight revenue, output GST' },
  { doc: 'Hire bill', icon: 'scale', to: 'Purchase voucher', detail: 'Vehicle hire · vendor net · TDS 194C payable' },
  { doc: 'Fuel / FASTag statement', icon: 'fuel', to: 'Diesel & Fuel · Toll Charges', detail: 'One line per vehicle, as cost centre' },
  { doc: 'Workshop job card', icon: 'wrench', to: 'Vehicle Repairs & Maintenance', detail: 'Parts from stores and outside bills' },
  { doc: 'Driver cash at settlement', icon: 'wallet', to: 'Staff Advances', detail: 'Against the driver’s own account' },
];

const PostingMap = () => (
  <div className="pp-doc" role="img" aria-label="Where each fleet document is booked in Finance">
    <div className="pp-doc-head">
      <span>Where fleet documents land in Finance</span>
      <span className="pp-chip pp-chip--ok">Booked once</span>
    </div>
    <ul className="fl-postings">
      {POSTINGS.map((p) => (
        <li key={p.doc}>
          <span className="pp-timeline-dot"><Icon name={p.icon} size={14} /></span>
          <span className="fl-post-doc">{p.doc}</span>
          <Icon name="arrow-right" size={14} className="fl-post-arrow" />
          <span className="fl-post-to"><strong>{p.to}</strong><small>{p.detail}</small></span>
        </li>
      ))}
    </ul>
    <div className="pp-doc-foot"><Icon name="info" size={13} />Every cost is booked once: a fuel-card fill sits on its trip but is posted only with the statement.</div>
  </div>
);

const FleetManagementPage = () => (
  <ProductPage page={FLEET_PAGE} heroVisual={<TripMock />} booksVisual={<PostingMap />} />
);

export default FleetManagementPage;
